import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  LegalArticle,
  LegalArticlePage,
  LegalCategory,
} from '../models/legal-article.model';

@Injectable({ providedIn: 'root' })
export class LegalService {
  private base = `${environment.apiUrl}/api/v3/api/legal`;

  constructor(private http: HttpClient) {}

  /** Recherche paginée avec filtres optionnels */
  search(
    q        = '',
    category = '',
    page     = 1,
    perPage  = 15,
  ): Observable<LegalArticlePage> {
    let params = new HttpParams().set('page', page).set('per_page', perPage);
    if (q.trim())       params = params.set('q', q.trim());
    if (category.trim()) params = params.set('category', category.trim());
    return this.http.get<LegalArticlePage>(`${this.base}/articles`, { params });
  }

  /** Détail d'un article */
  getArticle(id: number): Observable<{ data: LegalArticle }> {
    return this.http.get<{ data: LegalArticle }>(`${this.base}/articles/${id}`);
  }

  /** Liste des catégories avec compteurs */
  getCategories(): Observable<{ data: LegalCategory[] }> {
    return this.http.get<{ data: LegalCategory[] }>(`${this.base}/categories`);
  }
}
